module.exports = __webpack_public_path__ + "static/img/4.b614d57.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/6/1/eng/4.png
// module id = Cqus
// module chunks = 0